import * as React from 'react';
import {FunctionComponent} from 'react';

interface OwnProps {
    value: {min: number; max: number};
    onChange: (range: {min: number; max: number}) => void;
    min: number;
    max: number;
    step: number;
}

export const DualRange: FunctionComponent<OwnProps> = ({value, min, max, step, onChange}) => {
    const handOffPoint = Math.floor((value.min + value.max) / 2);
    const left = {
        min: min,
        max: handOffPoint,
        widthFraction: handOffPoint / max,
    };
    const right = {
        min: handOffPoint,
        max: max,
        widthFraction: (max - handOffPoint) / max,
    };

    return (
        <div className="form-dualrange">
            <input
                type="range"
                className="form-range form-range-left"
                value={value.min}
                onChange={(event) => {
                    const newMin = parseInt(event.target.value, 10);
                    onChange({min: newMin < value.max ? newMin : value.min, max: value.max});
                }}
                onDoubleClick={() => {
                    onChange({min: min, max: value.max});
                }}
                min={left.min}
                max={left.max}
                step={step}
                style={{
                    flex: left.widthFraction,
                }}
            />
            <input
                type="range"
                className="form-range form-range-right"
                value={value.max}
                onChange={(event) => {
                    const newMax = parseInt(event.target.value, 10);
                    onChange({min: value.min, max: newMax > value.min ? newMax : value.max});
                }}
                onDoubleClick={() => {
                    onChange({min: value.min, max: max});
                }}
                min={right.min}
                max={right.max}
                step={step}
                style={{
                    flex: right.widthFraction,
                }}
            />
        </div>
    );
};
